module.exports = __webpack_public_path__ + "img/36.9343386c.jpg";